<template>
  <liste-template :without-entete="isCartographie">
    <template #header>
      <h1 class="title is-size-3">
        {{ $t("listeProduitEcran.tabs.title") }}
      </h1>
      <breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template #action>
      <qd-button
        class="button is-addOrEdit"
        @click="checkPermissions(permCatalogue.maj)
          ? $router.push({ name: 'm.bodac.catalogue-nouveauNumerique' })
          : showPopUp()"
        :class="{ 'button-access-no-permission': !checkPermissions(permCatalogue.maj) }">
        {{ $t("listeProduitEcran.actions.add") }}
      </qd-button>
    </template>
    <template #bar-left>
      <div class="column is-narrow">
        <selecteur-action
          @handleAction="handleAction"
          :options="actions"
          :placeholder="$t('general.placeHolder.groupedAction')"
          :titleButton="'general.button.apply'"
          :elementsSelectionnes="getAllProduitEcranNumerique().length > 0"
        ></selecteur-action>
      </div>
      <form @submit.prevent="recherche()" class="column is-5 pdr-0 pdl-0">
        <b-input
          :placeholder="$t('general.button.search')"
          type="search"
          v-model="criteresRecherche.auto"
          icon="magnify"
        >
        </b-input>
      </form>
      <div class="column is-narrow">
        <button class="button" @click="setShowFiltre">
          <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
          <span class="is-size-7"
            >{{ $t("general.button.filtre") }}
            <label class="has-text-weight-bold" :class="nombreCritere > 0 ? '' : 'is-invisible'">
              ({{ nombreCritere }})
            </label>
          </span>
        </button>
        <span @click="reinitialiser()" class="info-circle-right is-pulled-right is-cursor-pointer">
          <b-icon icon="close-circle" type="is-danger"></b-icon>
        </span>
      </div>
    </template>
    <template #bar-right>
      <b-field class="column mg-0 pdr-0">
        <b-checkbox-button
          v-model="withoutImage"
          type="is-primary"
          outlined
          @input="recherche">
          <b-icon
            :icon="withoutImage ? 'image-off-outline' : 'image-outline'"
            class="mg-0">
          </b-icon>
        </b-checkbox-button>
      </b-field>
      <div class="column is-narrow" v-if="!isCartographie">
          <exportExcelButton
            :perm="permCatalogue.exporter"
            :query="exportExcelQuery"/>
      </div>
      <div>
        <parametrage-table
          v-if="startArrayRendering && !isCartographie"
          :reference-table="referenceTable">
        </parametrage-table>
      </div>
    </template>
    <template #content>
      <v-server-table
        url=""
        v-if="startArrayRendering"
        :columns="columns"
        :options="options"
        @loaded="finLoading"
        @loading="debutLoading"
        :ref="referenceTable"
      >
        <template slot="afterTable">
          <table-items-in-view @input="$refs[referenceTable].setLimit($event)" />
        </template>
        <template slot="selected" slot-scope="props">
          <div class="has-text-centered">
            <b-checkbox v-model="props.row.selected"
                    :value="props.row">
            </b-checkbox>
          </div>
        </template>
        <template slot="image" slot-scope="props" >
          <div class="has-text-centered">
            <image-view
              :permission="permCatalogue"
              :image="props.row.cheminMin"
              :imageTooltip="props.row.chemin"
              :id="props.row.id"
              :libelle="props.row.libelle"
            />
          </div>
        </template>
        <template slot="reference" slot-scope="props">
          <router-link
          class="lien"
          :class="{'text-access-no-permission':
                      !checkPermissions(permCatalogue.lecture)}"
            :to="{ name: 'c.bodac.catalogue-ecranNumerique',
            params: { id: props.row.id, isFromListeProduitEcran: true } }"
          >
            {{ props.row.reference }}
          </router-link>
        </template>
        <template slot="affectation" slot-scope="props">
          <div>
            <info-affectations :row="props.row"
                :affectations="props.row.affectations"
                :faceMotifNonComId="props.row.produitEcranNumerique.faceMotifNonComId"
                :isFromLigneFace="false">
            </info-affectations>
          </div>
        </template>
        <template slot="regroupementProduit" slot-scope="props">
          <span v-if="props.row.regroupementProduit">
            <router-link-blank
              :to="{
                name: 'c.bodac.catalogue-detailRegroupementProduit',
                params: { id: props.row.regroupementProduit.id },
              }"
              :message="props.row.regroupementProduit.code"
            />
          </span>
        </template>
        <template slot="societe" slot-scope="props">
          {{ getLibelleSociete(props.row.supportCommercial.societeId) }}
        </template>
        <template slot="agence" slot-scope="props">
          {{ getAgenceLibelle(props.row.agenceId) }}
        </template>
        <template slot="adresse" slot-scope="props">
          {{ props.row.produitEcranNumerique.adresse | adresse }}
        </template>
        <template slot="actif" slot-scope="props">
          {{ props.row.actif ? $t("general.non") : $t("general.oui") }}
        </template>
        <template slot="etat" slot-scope="props">
          {{ $t(getEtatEcran(props.row.produitEcranNumerique)) }}
        </template>
        <template slot="addSelection" slot-scope="props">
          <button
            @click="
              $emit(isInSelection(props.row) ? 'removeSelection' : 'addSelection', [props.row])
            "
            class="ripple button width-100percent"
            :class="isInSelection(props.row) ? 'is-success' : 'is-primary'"
          >
            <b-icon icon="plus-circle"></b-icon>
          </button>
        </template>
        <template slot="edit" slot-scope="props">
          <div class="has-text-centered">
            <btn-action-icon
              :permission="permCatalogue.maj"
               :disabled="isModifiableIntoHolding(props.row)"
              @is-click="$router.push({
                name: 'm.bodac.catalogue-editionNumerique',
                params: { produitId: props.row.id },
              })"
              icon-type="is-success"
              icon="pencil-box-outline"
            >
            </btn-action-icon>
          </div>
        </template>
        <template slot="archiver" slot-scope="props">
          <div class="has-text-centered">
            <btn-action-icon
              :tooltip-label="getLabelTooltip(props.row)"
              :disabled="isSynchronized(props.row) || isModifiableIntoHolding(props.row)"
              :permission="permCatalogue.supprimer"
              :tooltip-position="!!getLabelTooltip(props.row) ? 'is-left' : 'is-top'"
              @is-click="openPopUpArchivage(props.row)"
              icon-type="is-default"
              :icon="props.row.actif ? 'archive' : 'archive-arrow-up'">
            </btn-action-icon>
          </div>
        </template>
        <template slot="delete" slot-scope="props">
          <div class="has-text-centered">
            <div
              @click="checkPermissions(permCatalogue.supprimer) ? inProgress() : showPopUp()"
              class="is-cursor-pointer"
              :class="{ disabled: isModifiableIntoHolding(props.row) }"
            >
              <b-icon
                type="is-danger"
                icon="delete-forever"
                :class="{
                  'text-access-no-permission':
                    !checkPermissions(permCatalogue.supprimer) ||
                    isModifiableIntoHolding(props.row),
                }"
              ></b-icon>
            </div>
          </div>
        </template>
      </v-server-table>
      <b-modal v-model="popUpArchivage"
      has-modal-card
      class="modal"
      @close="produitToArchive = null">
      <pop-up-archivage v-if="produitToArchive"
        :messHeader="$t(produitToArchive.actif
          ? 'listeProduitEcran.archivage.archiver' : 'listeProduitEcran.archivage.desarchiver')"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('listeProduitEcran.archivage.no')"
        :validate="$t('listeProduitEcran.archivage.yes')"
        @no="popUpArchivage = false"
        @yes="archiverProduit()"/>
    </b-modal>
    </template>
    <template #after-content>
      <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="errorForPopUp"
        :choiceEdition="choiceEdition"
        @editionChoose="edition"
      >
      </pop-up-edition>
    </b-modal>
    <a ref="lienDownload"></a>
    </template>
    <template #filter>
      <div class="componentBrief" v-show="showFiltre">
        <filtre-liste-produit-ecran
          :isCartographie="isCartographie"
          ref="filtreListeProduitEcran"
          @toggleFiltre="setShowFiltre"
          @recherche="makeRechercheFilter()"
        />
      </div>
    </template>
  </liste-template>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import inProgress from '@/services/general/inProgress';
import listeTemplate from '@/components/general/template/listeTemplate';
import messageSucces from '@/services/general/messageSucces';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import {
  EXPORT_EXCEL_PRODUIT_ECRAN,
  LISTE_CHOICE_EDITION_ECRAN_NUMERIQUE,
  CATEGORIE_DIVERS,
  CATEGORIE_LOCATION,
} from '@/configuration/catalogue/produitConf';
import {
  ACTION_MASS_EDITION,
} from '@/configuration/general/actionsConf';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import selecteurAction from '@/components/general/selecteurAction';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import TableItemsInView from '@/components/general/TableItemsInView';
import popUpArchivage from '@/components/general/popUpPrevention';
import { archiver } from '@/api/produit/produitNumerique';
import edition from '@/api/edition/index';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { ACTION_ADD_SELECTION, ACTION_DELETE_SELECTION } from '@/configuration/cartographie/cartographie';
import filtreListeProduitEcran from '@/components/catalogue/filtre/filtreListeProduitEcran';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import traductionLibelleEtat from '@/services/devisCommandes/traductionLibelleEtat';
import imageView from '@/components/general/imageView';
import parametrageTable from '@/components/general/parametrageTable';
import infoAffectations from '@/components/general/infoAffectations';
import { columnsSplice } from '@/services/general/columns';
import BtnActionIcon from '@/components/general/btnActionIcon';
import { REFERENCE_TABLE_PRODUIT_ECRAN } from '@/configuration/general/referenceTableConf';
import validationProduit from '@/services/catalogue/validation/validationProduit';
import popUpEdition from '@/components/factures/p_edition';

const Permissions = createNamespacedHelpers('permissions');
const Societes = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  props: {
    isCartographie: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      permCatalogue: CATALOGUE,
      showFiltre: false,
      popUpArchivage: false,
      produitToArchive: null,
      popUpEdition: false,
      affectations: [],
      unsubscribeValue: null,
      startArrayRendering: false,
      listeEtats: traductionLibelleEtat(this.$i18n, ETAT_DISPOSITIF_PUBLICITAIRE),
      choiceEdition: LISTE_CHOICE_EDITION_ECRAN_NUMERIQUE,
      referenceTable: REFERENCE_TABLE_PRODUIT_ECRAN,
      errorForPopUp: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      constantes: {
        TYPE_PDF,
      },
      withoutImage: true,
      PARAMETRES_KEYS,
    };
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
  },
  components: {
    exportExcelButton,
    imageView,
    parametrageTable,
    infoAffectations,
    popUpArchivage,
    breadcrumb,
    popUpEdition,
    selecteurAction,
    TableItemsInView,
    routerLinkBlank,
    filtreListeProduitEcran,
    listeTemplate,
    BtnActionIcon,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
      parametre: 'parametre',
    }),
    ...Societes.mapGetters({
      societesInformations: 'societesInformations',
      agencesInformations: 'agencesInformations',
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
      agenceActive: 'agenceActive',
      societeActive: 'societeActive',
    }),
    lastPayload() {
      return this.$store.getters[`${this.storeName}/lastPayload`];
    },
    ...User.mapGetters({
      user: 'user',
    }),
    storeName() {
      return this.isCartographie ? 'produitEcranCartographie' : 'produitEcranNumerique';
    },
    produitsEcran() {
      return this.$store.getters[`${this.storeName}/produits`];
    },
    totalCount() {
      return this.$store.getters[`${this.storeName}/totalProduits`];
    },
    criteresRecherche: {
      get() {
        return this.$store.getters[`${this.storeName}/criteresRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.storeName}/SET_CRITERES_RECHERCHE`, value);
      },
    },
    iconSelectTotal() {
      if (this.allProduitEcranNumerique) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    allProduitEcranNumerique() {
      return this.getAllProduitEcranNumerique().length === this.produitsEcran.length
        && this.produitsEcran.length > 0;
    },
    allInSelection() {
      return this.produitsEcran.every(p => this.selection?.find(s => s.id === p.id));
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'actif', 'eclaire', 'avecLiaisonsTarif'];
      if (this.societeActive.agences.length === 1) banCritereKey.push('agencesId');
      let nbCritere = calculNombreCritere(this.criteresRecherche, banCritereKey);
      if (this.criteresRecherche.actif !== null) nbCritere += 1;
      nbCritere += this.criteresRecherche.eclaire !== null ? 1 : 0;
      nbCritere += this.criteresRecherche.avecLiaisonsTarif !== null ? 1 : 0;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    columns() {
      const columns = [
        'selected',
        'addSelection',
        'image',
        'reference',
        'adresse',
        'produitEcranNumerique.adresse.codePostal',
        'produitEcranNumerique.adresse.ville',
        'produitEcranNumerique.adresse.departement',
        'etat',
        'produitEcranNumerique.format',
        'produitEcranNumerique.materielType',
        'produitEcranNumerique.support',
        'affectation',
        'agence',
        'societe',
        'regroupementProduit',
        'actif',
        'edit',
        'archiver',
        'delete',
      ];
      if (
        this.societesInformations.length === 1
        || this.filtrerProduitParSociete
        || this.filtrerProduitParAgence
      ) {
        columnsSplice(columns, 'societe');
      }
      if (this.user.agences.length <= 1) {
        columnsSplice(columns, 'agence');
      }
      if (!this.modulePresseActive) {
        columnsSplice(columns, 'regroupementProduit');
      }

      if (this.isCartographie) {
        columnsSplice(columns, 'edit');
        columnsSplice(columns, 'archiver');
        columnsSplice(columns, 'delete');
      } else {
        columnsSplice(columns, 'addSelection');
      }
      if (this.withoutImage) columnsSplice(columns, 'image');

      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          image: this.$i18n.t('listeProduitEcran.tabs.image'),
          reference: this.$i18n.t('listeProduitEcran.tabs.reference'),
          societe: this.$i18n.t('listeProduitEcran.tabs.societe'),
          'produitEcranNumerique.adresse.ville': this.$i18n.t('listeProduitEcran.tabs.ville'),
          'produitEcranNumerique.adresse.codePostal': this.$i18n.t('listeProduitEcran.tabs.codePostal'),
          'produitEcranNumerique.adresse.departement': this.$i18n.t('listeProduitEcran.tabs.departement'),
          adresse: this.$i18n.t('listeProduitEcran.tabs.adresse'),
          'produitEcranNumerique.format': this.$i18n.t('listeProduitEcran.tabs.format'),
          'produitEcranNumerique.materielType': this.$i18n.t('listeProduitEcran.tabs.materiel'),
          'produitEcranNumerique.support': this.$i18n.t('listeProduitEcran.tabs.support'),
          affectation: this.$i18n.t('listeProduitEcran.tabs.affectation'),
          agence: this.$i18n.t('listeProduitEcran.tabs.agence'),
          regroupementProduit: this.$i18n.t('listeProduitEcran.tabs.regroupementProduit'),
          actif: this.$i18n.t('listeProduitEcran.tabs.actif'),
          etat: this.$i18n.t('listeProduitEcran.tabs.etat'),
          edit: '',
          archiver: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
          addSelection: (h) => {
            return h(
              'button', {
                attrs: {
                  class: `ripple button width-100percent ${this.allInSelection ? 'is-success' : 'is-primary'}`,
                },
                on: {
                  click: () => {
                    this.manageAllInSelection();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: 'plus-circle',
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortable: [
          'reference',
          'produitEcranNumerique.adresse.ville',
          'produitEcranNumerique.format',
          'produitEcranNumerique.adresse.codePostal',
          'produitEcranNumerique.adresse.departement',
          'produitEcranNumerique.materielType',
          'produitEcranNumerique.support',
          'actif',
        ],
        columnsClasses: {
          selected: 'colonneSelected',
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
          addSelection: 'colonneSelected-35 is-paddingless',
        },
        requestFunction: ((data) => {
          data.withoutImage = this.withoutImage;
          if (this.filtrerProduitParAgence && this.criteresRecherche.agencesId.length === 0) {
            this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
          }
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          if (data.query.dateReferenceAffectation) {
            data.query.dureeAffectation = {
              dateDebut: data.query.dateReferenceAffectation,
              dateFin: data.query.dateReferenceAffectation,
            };
            delete data.query.dateReferenceAffectation;
          }
          if (this.user.agences.length === 1) {
            data.query.agencesId = [this.user.agences[0].agenceId];
          }
          if (this.filtrerProduitParSociete) {
            data.query.societeId = this.societeActiveId;
          }
          return this.loadProduits(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produitsEcran,
            count: this.totalCount,
          };
        }),
      };
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    breadcrumb() {
      return [
        {
          title: this.$i18n.t('listeProduitEcran.breadcrumb.racine'),
          route: this.$PAGE_DEFAULT,
          isActive: false,
        },
        { title: this.$i18n.t('listeProduitEcran.breadcrumb.liste'), route: '', isActive: true },
      ];
    },
    actions() {
      return [
        {
          action: ACTION_MASS_EDITION,
          translation: 'listeFactures.actions.edition',
          show: true,
        },
        {
          action: ACTION_ADD_SELECTION,
          translation: 'cartographie.actions.addSelection',
          show: this.isCartographie,
        },
        {
          action: ACTION_DELETE_SELECTION,
          translation: 'cartographie.actions.removeSelection',
          show: this.isCartographie,
        },
      ].filter(el => el.show);
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_PRODUIT_ECRAN,
        typeExport: null,
        filtres: {
          ...this.lastPayload,
          Query: {
            ...this.lastPayload.Query,
            currentSociete: this.societeActiveId,
          },
        },
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    ...Societes.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    loadProduits(data) {
      return this.$store.dispatch(`${this.storeName}/loadProduitsEcran`, data);
    },
    isInSelection(row) {
      return this.selection?.find((f) => f.id === row.id);
    },
    manageAllInSelection() {
      if (this.allInSelection) {
        this.$emit('removeSelection', this.produitsEcran);
      } else {
        this.$emit('addSelection', this.produitsEcran);
      }
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeProduitEcran.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    getAgenceLibelle(agenceId) {
      return this.agencesInformations.find((agence) => {
        return agence.agenceId === agenceId;
      })?.libelleAgence ?? '';
    },
    getLabelTooltip(produit) {
      let label = '';
      if (this.isSynchronized(produit)) label = this.$t('catalogue.info.produitSynchro');
      if (this.isModifiableIntoHolding(produit)) label = this.$t('catalogue.info.isNotModifiableIntoHolding');
      return label;
    },
    handleAction(action) {
      switch (action) {
        case ACTION_MASS_EDITION:
          if (this.checkPermissions(this.permCatalogue.editer)) {
            this.errorForPopUp.messages = [];
            this.errorForPopUp.haveError = false;
            this.popUpEdition = true;
          } else this.showPopUp();
          break;
        case ACTION_ADD_SELECTION:
          this.$emit('addSelection', this.produitsEcran.filter((el) => el.selected));
          break;
        case ACTION_DELETE_SELECTION:
          this.$emit('removeSelection', this.produitsEcran.filter((el) => el.selected));
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFactures.error.noActionSelect'));
          break;
      }
    },
    getAllProduitEcranNumerique() {
      return this.produitsEcran.filter((el) => { return el.selected; });
    },
    inProgress() {
      inProgress(this.$i18n);
    },
    openPopUpArchivage(produit) {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      this.produitToArchive = produit;
      this.popUpArchivage = true;
    },
    async archiverProduit() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiver(this.produitToArchive.id, this.produitToArchive.actif);
        messageSucces(this.$i18n.t(this.produitToArchive.actif
          ? 'listeProduitFace.archivage.sucessArchivage'
          : 'listeProduitFace.archivage.successDesarchivage'));
        this.produitToArchive = null;
        this.popUpArchivage = false;
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        if (e.response.data.error) {
          this.messagesErreurPopUp = validationProduit(e.response);
          this.errorPopUp = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getLibelleSociete(societeId) {
      return this.societesInformations.find((societe) => {
        return societe.id === societeId;
      })?.libelle ?? '';
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    selectAll() {
      const select = !this.allProduitEcranNumerique;
      this.produitsEcran.forEach((el) => {
        el.selected = select;
      });
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    updateAgenceAndRecherche() {
      if (this.filtrerProduitParAgence) {
        this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.recherche();
    },
    async edition(donnees, id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesErreurPopUp = [];
        const ids = id ? [id] : this.getAllProduitEcranNumerique().map((el => el.id));
        const response = await edition({
          ids: ids,
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async reinitialiser() {
      await this.$refs.filtreListeProduitEcran.initializeFiltre();
      this.$refs.filtreListeProduitEcran.viderCritere();
      this.$refs.filtreListeProduitEcran.appliquerCritere();
      this.showFiltre = false;
    },
    isSynchronized(produit) {
      return produit.produitEcranNumerique !== null
        && produit.produitEcranNumerique.materielId !== null;
    },
    getEtatEcran(ecran) {
      return this.listeEtats.find((etat) => {
        return etat.value === ecran?.materiel?.etat;
      })?.libelle ?? null;
    },
    isModifiableIntoHolding(produit) {
      return produit.supportCommercial.societeId !== this.societeActiveId
        && produit.supportCommercial.categorieVente !== CATEGORIE_LOCATION
        && produit.supportCommercial.categorieVente !== CATEGORIE_DIVERS;
    },
  },
  beforeDestroy() {
    if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
      this.unsubscribeValue();
    }
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
        PARAMETRES_INTERNE_KEYS.modulePresse.key,
      ]);
      await this.loadParametres([PARAMETRES_KEYS.faceMotifNonCom]);
      if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
        this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      }
      if (this.user.agences.length > 1) {
        this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.startArrayRendering = true;
      if (!this.isCartographie) this.setInformationPage(this.$t('pageGescom.produitEcranNumerique.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
